export default class DtoStatus {
    constructor(object) {
        this.code = object.code
        this.name = object.name
    }
}
